module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu ",
    attrs: {
      "data-keep-expanded": "false",
      "data-auto-scroll": "true",
      "data-slide-speed": "200"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "start open",
    class: {
      active: _vm.ui.activeMenu === 'intro'
    },
    attrs: {
      "id": "intro"
    }
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'info'
    },
    attrs: {
      "id": "info"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/",
      "data-ancestor": "intro",
      "data-parent": "info"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "icon-bar-chart"
  }), _vm._v("\n            关于平台")])])])]), _vm._v(" "), _c('li', {
    staticClass: "last",
    class: {
      active: _vm.ui.activeMenu === 'sys'
    }
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.auth('sys_role_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'sys_role_list'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "data-path": "/#/role",
      "data-ancestor": "sys",
      "data-parent": "sys_role_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v("\n            角色")])]) : _vm._e(), _vm._v(" "), (_vm.auth('sys_account_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'sys_account_list'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "data-path": "/#/account",
      "data-ancestor": "sys",
      "data-parent": "sys_account_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v("\n            账号")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'sys_account_changepwd'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "data-path": "/#/pwd",
      "data-ancestor": "sys",
      "data-parent": "sys_account_changepwd"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("\n            修改密码")])])])]), _vm._v(" "), (_vm.auth(['biz_lock_list', 'biz_log_list', 'biz_addr_list', 'biz_lift_list'])) ? _c('li', {
    staticClass: "last",
    class: {
      active: _vm.ui.activeMenu === 'lock'
    },
    attrs: {
      "id": "lock"
    }
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.auth('biz_lock_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'biz_lock_list'
    },
    attrs: {
      "id": "biz_lock_list"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/#/lock",
      "data-ancestor": "lock",
      "data-parent": "biz_lock_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v("\n            iKEY设备")])]) : _vm._e(), _vm._v(" "), (_vm.auth('biz_lift_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'biz_lift_list'
    },
    attrs: {
      "id": "biz_lift_list"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/#/lift",
      "data-ancestor": "lock",
      "data-parent": "biz_lift_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v("\n            梯控设备")])]) : _vm._e(), _vm._v(" "), (_vm.auth('biz_liftbtn_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'biz_liftbtn_list'
    },
    attrs: {
      "id": "biz_liftbtn_list"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/#/liftbtn",
      "data-ancestor": "lock",
      "data-parent": "biz_liftbtn_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-up"
  }), _vm._v("\n            呼梯按键")])]) : _vm._e(), _vm._v(" "), (_vm.auth('biz_addr_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'biz_addr_list'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/#/addr",
      "data-ancestor": "lock",
      "data-parent": "biz_addr_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("\n            地址管理")])]) : _vm._e(), _vm._v(" "), (_vm.auth('biz_log_list')) ? _c('li', {
    class: {
      active: _vm.ui.activeSubmenu === 'biz_log_list'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-path": "/#/log",
      "data-ancestor": "lock",
      "data-parent": "biz_log_list"
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n            监控日志")])]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar-toggler-wrapper"
  }, [_c('div', {
    staticClass: "sidebar-toggler"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar-search-wrapper"
  }, [_c('form', {
    staticClass: "sidebar-search ",
    attrs: {
      "action": "#",
      "method": "POST"
    }
  }, [_c('a', {
    staticClass: "remove",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-magnifier"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("概况")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "arrow open"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("系统管理")]), _vm._v(" "), _c('span', {
    staticClass: "arrow "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-indent"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('span', {
    staticClass: "arrow "
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dae9bc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/sidebar.vue
// module id = 413
// module chunks = 2